import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/lib/http";

/**
 * TanStack Query yapılandırması.
 *
 * Bu uygulamada canlı güncelleme (realtime) yok ve veri saniyeler içinde
 * eskimiyor — lisanslar tek bir operatör tarafından, tek tek üretiliyor. Bu
 * yüzden pencereye her dönüşte yeniden çekmek yerine ölçülü bir tazelik süresi
 * kullanılıyor; değişiklik yapan her işlem zaten ilgili anahtarları geçersiz
 * kılıyor.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Yetki ve doğrulama hataları tekrar denemekle düzelmez; yalnızca
        // ağ/sunucu kaynaklı geçici hatalarda yeniden deniyoruz.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }

        return failureCount < 2;
      },
    },
    mutations: {
      // Yazma işlemlerini kendiliğinden tekrarlamak tehlikeli: aynı lisans iki
      // kez üretilebilirdi. Hata kullanıcıya gösterilir, kararı o verir.
      retry: false,
    },
  },
});
